import { useState } from 'react';
import {
    Typography,
    Box,
    Button,
    Stack,
    Snackbar,
    Alert,
    MenuItem,
    Grid,
    FormControl,
    InputLabel,
    Select
} from '@mui/material';
import { Breadcrumb } from 'components';
import SyncIcon from '@mui/icons-material/Sync';
import { syncApi } from 'services';


const list = [
    { id: -1, name: 'All' },
    { id: 1, name: 'Matrix' },
    { id: 2, name: 'MGTUser' },
    { id: 3, name: 'Client' },
    { id: 4, name: 'ClientAddress' },
    { id: 5, name: 'Location' },
    { id: 6, name: 'TestList' },
    { id: 7, name: 'PriceList' },
    { id: 8, name: 'TestLabLocation' },
    { id: 9, name: 'PriceListTest' },
    { id: 10, name: 'MethodDescription' },
    { id: 11, name: 'DetectionLimit' },
    { id: 12, name: 'BillingGroup' },
    { id: 13, name: 'BillingGroupMatrixType' },
    { id: 14, name: 'PriceListBillingGroup' },
    { id: 15, name: 'SetTest' },
    { id: 16, name: 'MatrixTestLabLocation' },
    { id: 17, name: 'BillingGroupTest' },
    { id: 18, name: 'Contact' },
    { id: 19, name: 'BusinessUnit' }
]

export const SyncData = () => {
    const [successRequest, setSuccessRequest] = useState(false);
    const [selectedId, setSelectedId] = useState('');
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const submitSyncApi = () => {
        syncApi(selectedId).then((res: any) => {
            if (res.status === 200) {
                setSuccessRequest(true);
            } else {
                setError(true);
                setErrorMessage(res.data);
                setSuccessRequest(false);
            }
        })
    }

    const handleSyncData = (event: any) => {
        setSelectedId(event.target.value);
    }

    let nav: any = [{ name: 'Home', path: '/home' }, { name: 'Admin', path: '/home/admin' }, { name: 'Library Sync', path: '/home/syncData' }];
    return (
        <div style={{ minHeight: '600px', paddingBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px 0', cursor: 'pointer' }}>
                <Breadcrumb navList={nav} />
            </div>
            <Typography variant="h6" gutterBottom align='left'>
                Library Sync
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    '& > :not(style)': {
                        marginTop: 0,
                        marginLeft: 0,
                        width: "100%",
                        maxWidth: "100%"
                    }
                }}
            >
                <Grid container spacing={2} sx={{ alignItems: 'flex-start' }}>
                    <Grid item xs={12} sm={6} md={4} style={{ paddingLeft: '0px' }}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label" sx={{ '&.Mui-focused': { color: 'secondary.main' } }}>Sync Data</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Sync Data"
                                value={selectedId}
                                onChange={handleSyncData}
                                sx={{
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'secondary.main',
                                    },
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 250,
                                            width: 'auto',
                                        },
                                    },
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }
                                }}
                            >
                                {list.map((item: any) => {
                                    return <MenuItem key={item.name} value={item.id}>{item.name}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', alignItems: 'flex-start', pt: { xs: 0, sm: 0 } }}>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            startIcon={<SyncIcon />} 
                            onClick={submitSyncApi}
                            disabled={selectedId === ''}
                            sx={{ 
                                width: { xs: '100%', sm: 'auto' },
                                minWidth: '150px'
                            }}
                        >
                            Sync Table
                        </Button>
                    </Grid>
                </Grid>
                <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
                    <Snackbar open={successRequest} autoHideDuration={6000} onClose={() => setSuccessRequest(false)}>
                        <Alert severity="success" onClose={() => setSuccessRequest(false)}><b>Data is syncing in the background!</b></Alert>
                    </Snackbar>
                    <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
                        <Alert severity="error" onClose={() => setError(false)}>{errorMessage}</Alert>
                    </Snackbar>
                </Stack>
            </Box>
        </div >
    );
}